<template>
    <v-container fluid class="py-0 px-0 mx-0">
        <v-row no-gutters class="mb-0">
            <v-col xl=12 lg=12 md=12 sm=12 xs=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
                <v-img
                    width="100vw"
                    :aspect-ratio="$vuetify.breakpoint.xs ? 1.25 : 1899 / 640"
                    :contain="!$vuetify.breakpoint.xs"
                    position="left center"
                    eager
                    alt="PARON CARD"
                    :src="heroImage">
                </v-img>
            </v-col>
            <v-col class="page-gutter" cols=12 style="color:#1b2f5a;" align=start>
                <div class="mt-10">
                    <span class="font-weight-bold">Ο Πολιτιστικός Αθλητικός Ριζοσπαστικός Οργανισμός Νέων (Π.Α.Ρ.Ο.Ν.)</span> είναι ένας σύλλογος που στόχο έχει την πολυεπίπεδη στήριξη των πολιτιστικών και αθλητικών συλλόγων και σωματείων της χώρας.
                    <div class="mt-5">
                        Όραμά του είναι η στήριξη μέσω  της αυτοχρηματοδότησης ώστε τα σωματεία να μπορούν να αναπτύσσονται, να αποκτούν αυτονομία και να οδηγούν τις ομάδες και τους αθλητές τους σε νέες διακρίσεις και επιτυχίες.
                    </div>
                </div>
            </v-col>
        </v-row>
        <paron-card-section/>
        <v-row no-gutters class="mt-10 page-gutter" justify="center" align="center">
            <v-col cols="12" class="mb-2">
                <section-title>Επιχειρήσεις - Εκπτώσεις</section-title>
            </v-col>
            <v-col
                v-for="partner in partners"
                :key="partner.id"
                cols="12"
                sm="6"
                lg="4"
                class="pa-2 pa-sm-3 mt-2 mt-sm-6 align-self-stretch"
            >
                <entity-card :entity="partner" kind="partner" />
            </v-col>
            <v-col cols=12 align=center>
                <v-btn color="#1b2f5a" dark x-large depressed class="mt-10 more-btn" to="/Partners">
                    Περισσότερα<v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="mt-12 mb-6">
                <a href="https://paron-card.ask2travel.com" target="_blank" rel="noopener" class="travel-card">
                    <img alt="ask2travel" :src="require('@/assets/ask2travel-logo.png')"/>
                    <div class="travel-card__text">
                        <div class="travel-card__title">
                            <v-icon color="#ad282d" class="mr-1">mdi-airplane</v-icon>Ταξίδια με έκπτωση
                        </div>
                        Κλείστε το ταξίδι σας, με διαμονή και μεταφορά, σε Ελλάδα ή εξωτερικό με σημαντικές εκπτώσεις σε συνεργασία με την ask2travel.
                    </div>
                    <span class="travel-card__cta">
                        Δείτε τις προσφορές<v-icon small color="#ad282d">mdi-open-in-new</v-icon>
                    </span>
                </a>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-10 mb-5 page-gutter" justify="center" align="center">
            <v-col cols="12" class="mb-2">
                <section-title>Σωματεία</section-title>
            </v-col>
        </v-row>
        <v-row class="page-gutter" no-gutters justify="center" align="center" style="background-color: #f2f4f8;">
            <v-col
                v-for="team in teams"
                :key="team.id"
                cols="12"
                sm="6"
                lg="4"
                class="pa-2 pa-sm-3 mt-2 mt-sm-6 align-self-stretch"
            >
                <entity-card :entity="team" kind="team" />
            </v-col>
            <v-col cols=12 align="center">
                <v-btn color="#1b2f5a" dark x-large depressed class="my-10 more-btn" to="/Teams">
                    Περισσότερα<v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-10 page-gutter" justify="center" align="center">
            <v-col cols="12" class="mb-2">
                <section-title>Νέα</section-title>
            </v-col>
        </v-row>
       <v-row no-gutters justify="center" align="center" class="mb-0 py-0 mt-10 page-gutter">
            <v-col cols=12>
                <news-carousel/>
            </v-col>
            <v-col cols=12 align="center">
                <v-btn color="#1b2f5a" dark x-large depressed class="my-10 more-btn" to="/News">
                    Περισσότερα<v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="center" justify="center" class="my-7 px-5 mx-0">
            <v-col cols="12" lg="4" align="center">
                <youtube-embed video-id="Lbr7m_td5YU" title="PARON CARD video" />
            </v-col>
            <v-col cols="12" lg="4" align="center">
                <youtube-embed video-id="7o3UB3lcemk" title="PARON CARD video" />
            </v-col>
            <v-col cols="12" lg="4" align="center">
                <youtube-embed video-id="9CRRtpIwW5A" title="PARON CARD video" />
            </v-col>
        </v-row>
    </v-container>
</template>    

<script>
import promoted from '@/services/promoted'
import NewsCarousel from '@/components/NewsCarousel.vue'
import ParonCardSection from '@/components/ParonCardSection.vue'
import YoutubeEmbed from '@/components/YoutubeEmbed.vue'
import EntityCard from '@/components/EntityCard.vue'
import SectionTitle from '@/components/SectionTitle.vue'

export default {
    components: { ParonCardSection, NewsCarousel, YoutubeEmbed, EntityCard, SectionTitle },
    data() {
        return {
            teams:[],
            partners:[],
            heroImage: require('@/assets/main new.jpg')
        }
    },
    created() {
      this.fetchTeams();
      this.fetchPartners();
    },
    methods: {
        fetchTeams() {
            promoted.teams().then(teams => {
                this.teams = teams
            }).catch(error => console.error(error))
        },
        fetchPartners() {
            promoted.partners().then(partners => {
                this.partners = partners
            }).catch(error => console.error(error))
        },
    }
}
</script>

<style lang="scss" scoped>
.travel-card {
    display: flex;
    align-items: center;
    gap: 28px;
    padding: 24px 28px;
    border: 1px solid rgba(27, 47, 90, 0.12);
    border-radius: 16px;
    background: linear-gradient(135deg, #fff 0%, #fff6ee 100%);
    color: #1b2f5a !important;
    text-decoration: none;
    font-size: 16px;
    line-height: 1.5;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.travel-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(27, 47, 90, 0.12);
}

.travel-card img {
    flex: 0 0 auto;
    width: 180px;
    height: auto;
}

.travel-card__text {
    flex: 1;
}

.travel-card__title {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    font-size: 20px;
    font-weight: 700;
}

.travel-card__cta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 0 0 auto;
    color: #ad282d;
    font-weight: 700;
    white-space: nowrap;
}

@media (max-width: 700px) {
    .travel-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;
        padding: 20px;
    }

    .travel-card img {
        width: 150px;
    }
}
</style>
